export const LOGO_URL = "https://customer-assets.emergentagent.com/job_placement-credit/artifacts/rwikb7go_Adora%20Montminy%20%284000%20x%204000%20px%29%20%281%29.png";
export const BROKER_PHOTO = "https://customer-assets.emergentagent.com/job_placement-credit/artifacts/h2un66b6_IMG_3254.jpeg";

export const CALENDLY_URL = "https://calendly.com/contact-mdcourtage/nouvelle-reunion";
export const PHONE = "06.88.07.38.33";
export const PHONE_TEL = "+33688073833";
export const EMAIL = "contact@mdcourtage.fr";
export const ADDRESS = "60 rue François 1er, 75008 Paris";

export const NAV_LINKS = [
  { href: "#services", label: "Services" },
  { href: "#apropos", label: "À propos" },
  { href: "#simulateur", label: "Simulateur" },
  { href: "#devis", label: "Devis" },
  { href: "#mentoring", label: "Mentoring" },
  { href: "#blog", label: "Conseils" },
  { href: "#faq", label: "FAQ" },
  { href: "/comparateur", label: "Comparateur", page: true },
  { href: "#contact", label: "Contact" },
];
